var map = {
	"./avatar-1.jpg": 83313,
	"./avatar-1577909_640.png": 14839,
	"./avatar-2.jpg": 51110,
	"./avatar-3.jpg": 41219,
	"./avatar-4.jpg": 22416,
	"./avatar-5.jpg": 67309,
	"./avatar-6.jpg": 98082,
	"./avatar-7.jpg": 89791,
	"./avatar-8.jpg": 62044,
	"./data": 10071,
	"./data.js": 10071,
	"./multi-user.jpg": 22757,
	"./user-dummy-img.jpg": 79404
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 40630;